import { render, staticRenderFns } from "./InputSubmission.vue?vue&type=template&id=840d4716&scoped=true&"
import script from "./InputSubmission.vue?vue&type=script&lang=js&"
export * from "./InputSubmission.vue?vue&type=script&lang=js&"
import style0 from "./InputSubmission.vue?vue&type=style&index=0&id=840d4716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840d4716",
  null
  
)

export default component.exports